import request from '@/utils/request'


// 查询免单记录列表
export function listFreeRecord(query) {
  return request({
    url: '/biz/admin/order/free/record/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询免单记录分页
export function pageFreeRecord(query) {
  return request({
    url: '/biz/admin/order/free/record/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询免单记录详细
export function getFreeRecord(data) {
  return request({
    url: '/biz/admin/order/free/record/detail',
    method: 'get',
    params: data
  })
}

// 新增免单记录
export function addFreeRecord(data) {
  return request({
    url: '/biz/admin/order/free/record/add',
    method: 'post',
    data: data
  })
}

// 修改免单记录
export function updateFreeRecord(data) {
  return request({
    url: '/biz/admin/order/free/record/edit',
    method: 'post',
    data: data
  })
}

// 删除免单记录
export function delFreeRecord(data) {
  return request({
    url: '/biz/admin/order/free/record/delete',
    method: 'post',
    data: data
  })
}
